<template>
    <span v-if="text && !isError">{{ text }}</span>
    <small v-else
        ><i class="text-default">{{ exceptionMessage }}</i></small
    >
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        text: { type: [String, Number], default: "" },
        isError: { type: Boolean, default: false },
        exceptionMessage: { type: String, default: "Not Available" }
    }
});
</script>
